module.exports = __webpack_public_path__ + "img/music-white.9f5a7d61.svg";